// Notificações (layouts/newstyle/_flash_messages): avisos flutuantes por cima da página.
// - As mensagens de flash já vêm renderizadas; aqui só ganham o fechar e o tempo de vida.
// - Sucesso, aviso e atenção somem sozinhos: a barra embaixo do aviso é uma animação de CSS
//   com a duração do tipo, e o aviso fecha quando ela termina (com o mouse em cima ou o foco
//   dentro, a animação pausa e o aviso espera). Erro fica até a pessoa fechar.
// - window.cdaToast('Mensagem', 'success' | 'error' | 'warning' | 'info', { duration: ms })
//   mostra um aviso novo a partir do JS (duration 0 = só fecha no X). A mensagem entra como texto.
// - Views antigas que ainda chamam display_flash_messages (login, painel, respostas .js.erb)
//   desenham um #flashes no meio do conteúdo; aqui ele vira notificação e sai da página (sem
//   repetir a mensagem que já veio no aviso do layout).

var DURATIONS = { success: 5000, info: 6000, warning: 8000, error: 0 };
var MAX_TOASTS = 4;

function toastKind(toast) {
  var match = toast.className.match(/cda-toast--(\w+)/);
  return match ? match[1] : 'info';
}

function dismiss(toast) {
  if (!toast || toast.classList.contains('is-leaving')) return;
  toast.classList.add('is-leaving');
  var done = false;
  function remove() {
    if (done) return;
    done = true;
    if (toast.parentNode) toast.parentNode.removeChild(toast);
  }
  toast.addEventListener('animationend', function(event) {
    if (event.target === toast) remove();
  });
  setTimeout(remove, 400);
}

function setup(toast, duration) {
  if (toast.getAttribute('data-cda-toast-bound') === '1') return;
  toast.setAttribute('data-cda-toast-bound', '1');

  if (duration === undefined) duration = DURATIONS[toastKind(toast)];
  var timer = toast.querySelector('.cda-toast__timer');

  if (duration > 0 && timer) {
    toast.style.setProperty('--cda-toast-duration', duration + 'ms');
    timer.addEventListener('animationend', function() { dismiss(toast); });
  } else {
    toast.classList.add('is-sticky');
  }

  var close = toast.querySelector('[data-cda-toast-close]');
  if (close) close.addEventListener('click', function() { dismiss(toast); });
}

function trimStack(container) {
  var toasts = container.querySelectorAll('[data-cda-toast]:not(.is-leaving)');
  for (var i = 0; i < toasts.length - MAX_TOASTS; i++) dismiss(toasts[i]);
}

function build(container, message, kind, options) {
  var template = container.querySelector('[data-cda-toast-template="' + kind + '"]');

  var toast = document.createElement('div');
  toast.className = 'cda-toast cda-toast--' + kind;
  toast.setAttribute('data-cda-toast', '');
  toast.setAttribute('role', kind === 'error' || kind === 'warning' ? 'alert' : 'status');

  var icon = document.createElement('span');
  icon.className = 'cda-toast__icon';
  if (template) icon.appendChild(template.content.cloneNode(true));

  var body = document.createElement('div');
  body.className = 'cda-toast__body';
  var title = document.createElement('p');
  title.className = 'cda-toast__title';
  title.textContent = template ? template.getAttribute('data-title') : '';
  var text = document.createElement('div');
  text.className = 'cda-toast__text';
  // html: só para conteúdo que já veio do servidor (mensagens de flash), nunca para texto do usuário
  if (options && options.html) text.innerHTML = message;
  else text.textContent = message;
  body.appendChild(title);
  body.appendChild(text);

  var close = document.createElement('button');
  close.type = 'button';
  close.className = 'cda-toast__close';
  close.setAttribute('data-cda-toast-close', '');
  close.setAttribute('aria-label', container.getAttribute('data-close-label') || '');
  close.innerHTML = '<svg class="cda-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var timer = document.createElement('span');
  timer.className = 'cda-toast__timer';
  timer.setAttribute('aria-hidden', 'true');

  toast.appendChild(icon);
  toast.appendChild(body);
  toast.appendChild(close);
  toast.appendChild(timer);
  return toast;
}

window.cdaToast = function(message, kind, options) {
  var container = document.querySelector('[data-cda-toasts]');
  if (!container || !message) return null;
  if (!DURATIONS.hasOwnProperty(kind)) kind = 'info';

  var toast = build(container, String(message), kind, options);
  container.appendChild(toast);
  setup(toast, options && options.duration !== undefined ? options.duration : DURATIONS[kind]);
  trimStack(container);
  return toast;
};

//
// Mensagens no formato antigo (#flashes .alert, do display_flash_messages)
//
var LEGACY_KINDS = { success: 'success', notice: 'success', error: 'error', alert: 'error',
                     warning: 'warning', question: 'info' };

function normalize(text) {
  return (text || '').replace(/\s+/g, ' ').trim();
}

function absorbLegacy(root) {
  var container = document.querySelector('[data-cda-toasts]');
  if (!container) return;

  var blocks = root.id === 'flashes' ? [root] : root.querySelectorAll('#flashes');
  Array.prototype.forEach.call(blocks, function(block) {
    Array.prototype.forEach.call(block.querySelectorAll('.alert'), function(alert) {
      var close = alert.querySelector('.close');
      if (close) close.parentNode.removeChild(close);

      var kindMatch = alert.className.match(/alert-(\w+)/);
      var kind = LEGACY_KINDS[kindMatch && kindMatch[1]] || 'info';
      var text = normalize(alert.textContent);
      if (!text) return;

      var shown = Array.prototype.some.call(container.querySelectorAll('.cda-toast__text'), function(el) {
        return normalize(el.textContent) === text;
      });
      if (!shown) window.cdaToast(alert.innerHTML.trim(), kind, { html: true });
    });
    if (block.parentNode) block.parentNode.removeChild(block);
  });
}

// respostas .js.erb que inserem um #flashes depois de a página carregar
var legacyObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    Array.prototype.forEach.call(mutation.addedNodes, function(node) {
      if (node.nodeType === 1 && (node.id === 'flashes' || node.querySelector('#flashes'))) absorbLegacy(node);
    });
  });
});
legacyObserver.observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('turbolinks:load', function() {
  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-toast]'), function(toast) {
    setup(toast);
  });
  absorbLegacy(document);
});

// a página guardada no cache do Turbolinks (voltar do navegador) não deve repetir os avisos
document.addEventListener('turbolinks:before-cache', function() {
  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-toast]'), function(toast) {
    toast.parentNode.removeChild(toast);
  });
});
